import { render, staticRenderFns } from "./HandInPaper.vue?vue&type=template&id=5056f229&scoped=true&"
import script from "./HandInPaper.vue?vue&type=script&lang=js&"
export * from "./HandInPaper.vue?vue&type=script&lang=js&"
import style0 from "./HandInPaper.vue?vue&type=style&index=0&id=5056f229&lang=less&scoped=true&"
import style1 from "./HandInPaper.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5056f229",
  null
  
)

export default component.exports